import { LocalStorage, LOCAL_STORAGE_KEYS } from 'utils';

export function readExpressDesignerSegment<T>(segment: string): Record<string, T> {
  try {
    const parsed = JSON.parse(LocalStorage.getItem(LOCAL_STORAGE_KEYS.EXPRESS_DESIGNER) ?? '{}');

    return (parsed[segment] as Record<string, T>) ?? {};
  } catch {
    return {};
  }
}
